<span [id]="'nc-label-' + id" fxLayout="row" fxLayoutGap="3px">
  <span>{{value | translate}}</span>
  <span fxLayout="column" fxLayoutAlign="center">
    <mat-icon *ngIf="tooltip" [matTooltip]="tooltip | translate" matTooltipPosition="right">
      <ng-container *ngIf="!isOutlineIcon">info</ng-container>
      <ng-container *ngIf="isOutlineIcon">info_outline</ng-container>
    </mat-icon>
  </span>
</span>
